// useDecrypted — Hook per decifrare on-demand un valore cifrato lato server.
// Chiama l'edge function /functions/v1/pgcrypto-decrypt che valida ruolo e tenant
// dell'utente (consulente/ristoratore) prima di restituire il plaintext.
//
// Le colonne consentite sono whitelisted lato server:
//   - suppliers.iban_encrypted
//   - tenant_fiscal_config.webhook_secret_encrypted
//
// Ogni decrittazione viene loggata su audit_log per compliance.

import { useMutation } from '@tanstack/react-query';
import { getSupabase, SUPABASE_URL } from '../supabase.js';

interface DecryptInput {
  table: 'suppliers' | 'tenant_fiscal_config';
  row_id: string;
  column: string;
}

interface DecryptResult {
  value: string | null;
}

export function useDecryptColumn() {
  return useMutation<string | null, Error, DecryptInput>({
    mutationFn: async (input) => {
      const { data: sess } = await getSupabase().auth.getSession();
      const token = sess.session?.access_token;
      if (!token) throw new Error('Non autenticato');
      const res = await fetch(
        `${SUPABASE_URL.replace(/\/$/, '')}/functions/v1/pgcrypto-decrypt`,
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify(input),
        },
      );
      if (!res.ok) {
        const t = await res.text();
        throw new Error(`HTTP ${res.status}: ${t.slice(0, 200)}`);
      }
      const json = (await res.json()) as DecryptResult;
      return json.value;
    },
  });
}
